import { CustodyOrder } from "../models/CustodyOrder";
import api from "./api";
import { clean } from "../utils/utils";
import { File } from "../models/File";

const PATH = "/api/v1/custody-orders";

export const CustodyOrderService = {
  async getCustodyOrder(custodyOrderId: string): Promise<CustodyOrder | null> {
    const res = await api.get(`${PATH}/${custodyOrderId}`);
    return res.data.data;
  },

  async getAllCustodyOrders(matterId: string): Promise<CustodyOrder[]> {
    const res = await api.get<CustodyOrder[]>(PATH, {
      params: { matterId },
    });
    return res.data;
  },

  async createCustodyOrder(
    file: globalThis.File | null,
    custodyOrderData: Omit<
      CustodyOrder,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById"
    >,
  ): Promise<CustodyOrder["_id"]> {
    const formData = new FormData();
    formData.append("type", custodyOrderData.type);
    formData.append("matterId", custodyOrderData.matterId!);
    if (file) formData.append("file", file);
    if (custodyOrderData.title)
      formData.append("title", custodyOrderData.title);
    if (custodyOrderData.description)
      formData.append("description", custodyOrderData.description);
    if (custodyOrderData.orderDate)
      formData.append("orderDate", custodyOrderData.orderDate.toISOString());
    const res = await api.post(`${PATH}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data.data._id;
  },

  async updateCustodyOrder(
    matterId: string,
    custodyOrderId: string,
    updatedData: Partial<Omit<CustodyOrder, "_id" | "createdAt">>,
  ): Promise<void> {
    await api.put(`${PATH}/${custodyOrderId}`, {
      ...clean(updatedData),
      matterId,
    });
  },

  async deleteCustodyOrder(custodyOrderId: string): Promise<void> {
    await api.delete(`${PATH}/${custodyOrderId}`);
  },

  async getFiles(custodyOrderId: string): Promise<File[]> {
    const res = await api.get(`${PATH}/${custodyOrderId}/files`);
    return res.data.data ?? [];
  },

  async getDownloadURL(custodyOrderId: string): Promise<string> {
    const res = await api.get(`${PATH}/${custodyOrderId}/download`);
    return res.data.data.url;
  },
};
